
import './style/jobs.css';
import Job from './Job';
import { useContext, useState } from 'react';
import { AppContext } from '../../../contextApi/ContextApi';
import NotFound404 from '../../NotFound404';
import SearchTermFilter from '../../SearchTermFilter';

export default function Jobs({website}) {
  const {accent_color, primary_color, hasJobs} = useContext(AppContext);
  const [jobs, setJobs] = useState(website?.settings?.jobs || []);
  if(!hasJobs) return <NotFound404/>
  const deployJobs=()=>{
    if(jobs?.length <= 0){
      return (
        <div style={{margin:"0 auto 200px", textShadow:`2px 2px 4px ${primary_color}`, color:`${accent_color}`}}>
          <h2>מתנצלים.. כרגע אנחנו בתפוסה מלאה</h2>
          <h3>מוזמנים לבדוק שוב בהמשך..</h3>
        </div>
      )
    }
    return jobs.map((val,inx)=>{
      return <Job key={`job_${val.title}_${inx}`} website={website} job={val} inx={inx}/>
    })
  }

  return (
    <div id='jobsComponentMainContainer' dir='rtl'>
      <h1 style={{margin:"50px auto", textShadow:`2px 2px 4px ${primary_color}`, color:`${accent_color}`, fontSize:"35px"}}>דרושים עובדים לחברת {website?.settings?.website_name}</h1>
      {/* add a dropdown filter by createdAt => to display oldest/newest jobs */}
      <SearchTermFilter list={website?.settings?.jobs} setList={setJobs} filterBy={{title:true}} searchInputPlaceholder={"חפש משרה לפי שם התפקיד.."}/>
      {deployJobs()}
    </div>
  )
}
